'use strict';

function parsePartitionCoefficient(value) {
  if (value === null || value === undefined) return null;
  const raw = String(value).trim();
  if (!raw) return null;
  if (!/^[+-]?(?:\d+(?:[.,]\d*)?|[.,]\d+)(?:[eE][+-]?\d+)?$/.test(raw)) return null;
  const parsed = Number(raw.replace(',', '.'));
  return Number.isFinite(parsed) ? parsed : null;
}

function usableCpcRows(cpcData) {
  return (Array.isArray(cpcData) ? cpcData : []).map((row, index) => ({ row, index, partitionCoefficient: parsePartitionCoefficient(row && row.Kd) }));
}

module.exports = { parsePartitionCoefficient, usableCpcRows };
